<app-layout-container [useCard]="false">
  <div class="login-background" [style.background-image]="backgroundUrl"></div>

  <main class="container">
    <div class="row">
      <div class="col-md-4 offset-md-4">
        <div class="card card-login">
          <div class="card-body">
            <h4 class="mb-0">{{ 'error.couldNotLoadPublicBuilding' | translate }}</h4>
          </div>
        </div>
      </div>
    </div>
  </main>
</app-layout-container>
